import React from 'react';
import { ApiCalls, emptyResponseData, ICrewData, ICrewResponseData } from '../../ApiCalls';
import { useSelector } from 'react-redux';
import { selectedYachtState } from '../../redux/slices/yachtSlice';
import { GlobalStyles } from '../../GlobalStyles';
import { ReduxUpdater } from '../../redux/ReduxUpdater';
import { Navigate } from 'react-router-dom';
import { GlobalConstants } from '../../GlobalConstants';
import { Column, DataTable } from './elements/Forms/DataTable';

const EmployeesContent = () => {
    const currentSelectedYachtState = useSelector(selectedYachtState);
    const CrewDataPageSize = 100;

    const [crewData, setCrewData] = React.useState<ICrewResponseData>(emptyResponseData);
    const [CrewDataPage, setCrewDataPage] = React.useState(1);
    const [isDataLoading, setIsDataLoading] = React.useState(false);

    React.useEffect(() => {
        if (!currentSelectedYachtState) {
            return;
        }
        setIsDataLoading(true);
        ApiCalls.employees(currentSelectedYachtState.id, CrewDataPage, CrewDataPageSize).then(d => {
            setCrewData(d);
            setIsDataLoading(false);
        }).catch(err => {
            console.error(err);
            setIsDataLoading(false);
        });
    }, [currentSelectedYachtState, CrewDataPage, CrewDataPageSize]);

    if ([GlobalConstants.UserRole.STANDARD, GlobalConstants.UserRole.BASIC].includes(ReduxUpdater.authenticatedUser?.user_role ?? '')) {
        return <Navigate to="/expenses" replace />;
    }

    if (!currentSelectedYachtState) {
        return <>Please select Yacht first!!!</>;
    }

    const EmployeesCOLUMNS: Column<ICrewData>[] = [
        {
            key: "photo",
            label: "Photo",
            width: "1fr",
            sortable: false,
            render: (_, row) => (
                <img
                    className="h-8 w-8"
                    src={row.profile_image_bytes}
                    alt={row.first_name + ' ' + row.last_name}
                />
            ),
        },
        {
            key: "name",
            label: "Name",
            width: "2fr",
            sortable: false,
            render: (_, row) => (<>{row.first_name + ' ' + row.last_name}</>),
        },
        {
            key: "position",
            label: "Rank",
            width: "3fr",
            sortable: false,
        },
        {
            key: "phone_number",
            label: "Phone",
            width: "2fr",
            sortable: false,
        },
        {
            key: "expense_card",
            label: "Expense Card",
            width: "1fr",
            align: "center",
            sortable: false,
            render: (_, row) => (<>{!row.debit_card_number || row.debit_card_number.length < 5 || row.debit_card_number.includes('X') || (row.card_name ?? '').toLowerCase() === 'kx' ? 'N/A' : `${row.debit_card_number} (${row.card_name})`}</>),
        },
        {
            key: "user_role",
            label: "User Role",
            width: "1fr",
            sortable: false,
        },
        {
            key: "action",
            label: "Action",
            width: "1fr",
            align: "right",
        },
    ];

    return (
        <div className="max-w-[1000px] self-stretch px-4 inline-flex flex-col justify-center items-start gap-1 fill-available">
            <div className="self-stretch px-4 inline-flex justify-start items-center gap-2">
                <div className="w-64 h-12 relative">
                    <div className="w-64 left-0 top-0 absolute justify-start text-Text-Default-Default text-2xl font-semibold font-['Inter'] leading-7">Employees</div>
                    <div className="w-65 left-0 top-[33px] absolute justify-start text-text-lighter text-base font-normal font-['Inter'] leading-4">Tony Lovec Yacht Management</div>
                </div>
            </div>
            <DataTable<ICrewData>
                className='w-full mb-4'
                columns={EmployeesCOLUMNS}
                data={crewData.items.sort((a, b) => {
                    if (b.position !== a.position) {
                        return GlobalConstants.SORT.POSITIONS.indexOf(a.position) - GlobalConstants.SORT.POSITIONS.indexOf(b.position);
                    }

                    if (b.user_role !== a.user_role) {
                        return GlobalConstants.SORT.ROLES.indexOf(b.user_role) - GlobalConstants.SORT.ROLES.indexOf(a.user_role);
                    }

                    return `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`);
                })}
                pagination={{ page: CrewDataPage, pageSize: CrewDataPageSize, total: -1 }}
                loading={isDataLoading}
                onPageChange={setCrewDataPage}
                onPageSizeChange={() => {}}
                onRowClick={() => {}}
                rowCss={(r, i) => currentSelectedYachtState?.callsign === r.callsign ? 'h-12 min-h-12 bg-gray-200' : 'h-12 min-h-12'}
                styles={GlobalStyles.DataTable.table}
            />
        </div>
    );
};

export default EmployeesContent;